import React from "react";
import { MessageInput } from "stream-chat-react";

interface CustomMessageInputProps {
    shouldFocus?: boolean;
}

const CustomMessageInput: React.FC<CustomMessageInputProps> = ({shouldFocus}) => {
    return (
        <MessageInput
            focus={shouldFocus}
            grow={true}
        />
    )
}

export default CustomMessageInput;